const map = {
	"./www1.svg": [
		4621,
		[
			4621
		]
	],
	"./www10.svg": [
		91991,
		[
			1991
		]
	],
	"./www11.svg": [
		93958,
		[
			3958
		]
	],
	"./www12.svg": [
		16389,
		[
			6389
		]
	],
	"./www2.svg": [
		21646,
		[
			1646
		]
	],
	"./www3.svg": [
		36287,
		[
			6287
		]
	],
	"./www4.svg": [
		18816,
		[
			8816
		]
	],
	"./www5.svg": [
		33201,
		[
			3201
		]
	],
	"./www6.svg": [
		76098,
		[
			6098
		]
	],
	"./www7.svg": [
		79827,
		[
			9827
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 23750;
module.exports = webpackAsyncContext;